import React from "react";
import styled from "styled-components";

interface ScrollableDivProps {
  className?: string;
  childrenClassName?: string;
  children: React.ReactNode;
}
export const ScrollableDiv: React.FC<ScrollableDivProps> = ({ children, className, childrenClassName }) => (
  <FaderContainer className={className}>
    <ScrollContainer className={childrenClassName}>{children}</ScrollContainer>
  </FaderContainer>
);

const FaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;

  ::before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 15px;
    height: 15px;
    pointer-events: none;
    z-index: 1;
  }

  ::after {
    position: absolute;
    content: "";
    pointer-events: none;
    bottom: 0;
    left: 0;
    right: 15px;
    height: 15px;
  }
`;

const ScrollContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  width: 100%;
  height: 100%;
`;
